import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getDaiToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.DAI,
    symbol: 'DAI',
    addressL1: sdks.L1.getContractAddress('DAI'),
    addressL2: '',
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 2,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/dai.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="dai"
        {...props}
      />
    ),
  };
};
